import { render, staticRenderFns } from "./ArticleMemberSave.vue?vue&type=template&id=42641dd2&"
import script from "./ArticleMemberSave.vue?vue&type=script&lang=js&"
export * from "./ArticleMemberSave.vue?vue&type=script&lang=js&"
import style0 from "./ArticleMemberSave.vue?vue&type=style&index=0&id=42641dd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports